import type { TOC } from '@ember/component/template-only';
import LoadingSpinnerPulse from 'garaje/components/ui/classic/loading-spinner-pulse';
import type { ColumnHeader } from 'garaje/components/ui/table';
import UiTable from 'garaje/components/ui/table';
import type VisitorProfile from 'garaje/models/visitor-profile';

import NameCell from './name-cell';
import VisitCell from './visit-cell';

interface DirectoryTableSignature {
  Args: {
    isLoading: boolean;
    visitorProfiles: VisitorProfile[];
  };
}

const COLUMN_HEADERS: ColumnHeader[] = [
  {
    key: 'fullName',
    label: 'Name',
    sortable: false,
    class: 'w-2/5',
    componentOptions: {
      template: NameCell,
    },
  },
  {
    key: 'relevantVisit',
    label: 'Visit date',
    sortable: false,
    class: 'w-1/5',
    componentOptions: {
      // @ts-expect-error: TS does not like matching class components to `ComponentLike`
      template: VisitCell,
    },
  },
  {
    key: 'formattedPhoneNumber',
    label: 'Phone number',
    sortable: false,
    class: 'w-1/5',
  },
  {
    key: 'relevantVisit.locationName',
    label: 'Visit location',
    sortable: false,
    class: 'w-1/5',
  },
];

export default <template>
  <div data-test-profiles-directory-table class="!mt-0 relative">
    {{#if @isLoading}}
      <div class="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center">
        <LoadingSpinnerPulse />
      </div>
    {{/if}}
    <UiTable
      class="mb-4 table-fixed"
      @columnHeaders={{COLUMN_HEADERS}}
      @data={{@visitorProfiles}}
      @headerClass="text-sm pt-1 pb-3 px-3 align-middle font-medium"
    />

  </div>
</template> satisfies TOC<DirectoryTableSignature>;
